module.exports = __webpack_public_path__ + "static/computerImage-4e012feb56850195d310cd92af4612bc.jpeg";